import { F as attr_style, x as stringify } from "./index2.js";
import { e as escape_html } from "./escaping.js";
function PageHeadingSection($$renderer, $$props) {
  let { title, imageUrl } = $$props;
  $$renderer.push(`<div class="page-heading-section svelte-qq48a3"${attr_style(`background-image: url(${stringify(imageUrl)});`)}><div class="container svelte-qq48a3"><h1 class="page-heading-section__heading svelte-qq48a3">${escape_html(title)}</h1></div></div>`);
}
export {
  PageHeadingSection as P
};
